import React from 'react'
import PropTypes from 'prop-types'

import Box from '@mui/material/Grid'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

import ChromeIcon from '../icons/Chrome'
import EdgeIcon from '../icons/Edge'
import OperaIcon from '../icons/Opera'
//import SettingsIcon from '@mui/icons-material/Settings'

const Home = (props) => {
    return (
        <Grid
            container
            spacing={0}
            direction='column'
            alignItems='center'
            justifyContent='center'
            backgroundColor='#ece9e9'
        >
            <Grid item xs={3}>
                  <Box align='center' sx={{ mb: 4 }}> 

                    <img
                        src='/logo.png'
                        alt='FOULE.ING'
                        style={{ width: '200px', height: 'auto', margin: 'center' }}
                    />

                  
                  </Box>

                   <Box align='center' sx={{ mb: 4 }}> 

                    <text
                        style={{
                            fontSize: '1.5rem',
                            fontFamily: 'DIN Alternate',
                            fontWeight: 'bold',
                            color: '#000000',
                            textAlign: 'center',
                            marginTop: '1.5rem',
                        }}  
                    >
                        Foule.ing UC-1 Flashing Tool
                    </text> 
                    </Box>

                {props.supported() ?
                    <Box align='center'>
                        <Box>
                           <Button
                            variant='contained'
                            size='large'
                            onClick={props.connect}
                            sx={{
                                m: 1,
                                backgroundColor: '#000000',
                                color: '#ffffff',
                                '&:hover': {
                                backgroundColor: '#333333',
                                   '&:hover': {
                                backgroundColor: '#6d8f93',
                                },
                                },
                            }}
                            >

                                Connect the UC-1
                            </Button>
                        </Box>

                        {/* <Box>
                            <Button size='large' onClick={props.openSettings} sx={{ m: 1, color:'#bebebe' }}>
                                <SettingsIcon />
                            </Button>
                        </Box> */}
                        <Box align='center' sx={{ mb: 4 }}></Box>
                        <Alert 
                        severity='info' 
                        align='left' 
                        sx={{   color: '#000000',
                                backgroundColor: '#f0f0f0',
                                fontSize: '1rem',
                                fontFamily: 'DIN Alternate',
                                fontWeight: 'bold',
                                  '& .MuiAlert-icon': {
                                    color: '#6d8f93', // <- mets ici la couleur souhaitée de l'icône
        },
                                
                        }}>
                            1. Click on Connect the UC-1<br />
                            2. Plug in your ESP & select the port<br />
                            3. Add your .bin & set the address<br />
                            4. Click Program to flash it<br />
                        </Alert>
                       </Box> 
                    //</Box>

                    :

                    <Alert severity='warning'>
                        <AlertTitle>Your browser doesn&apos;t support Web Serial 😭</AlertTitle>
                        Try using&nbsp;
                        <a href='https://www.google.com/chrome/' target='blank'>
                            <ChromeIcon fontSize='inherit' /> <b>Chrome</b>
                        </a>
                        ,&nbsp;
                        <a href='https://www.microsoft.com/en-us/edge' target='blank'>
                            <EdgeIcon fontSize='inherit' /> <b>Edge</b>
                        </a>
                        , or&nbsp;
                        <a href='https://www.opera.com/' target='blank'>
                            <OperaIcon fontSize='inherit' /> <b>Opera</b>
                        </a>
                        <br />
                        (IOS & Android browsers are not supported)
                        <br />
                        <br />
                        Learn more about&nbsp;
                        <a href='https://developer.mozilla.org/en-US/docs/Web/API/Serial#browser_compatibility' target='blank'>
                            browser compatibility
                        </a>
                    </Alert>
                }
            </Grid>

        </Grid>
    )
}

Home.propTypes = {
    connect: PropTypes.func,
    supported: PropTypes.func,
    openSettings: PropTypes.func,
}

export default Home